import React from 'react'

const HeroContent = () => (
  <>
    <strong>Updates from an institution that cares.</strong>
    <br />
    Just as it’s important for patients to find healthcare providers they can trust, UMA believes
    in offering trustworthy information to the decision-makers who help shape this industry. Our
    contributors to this blog carefully cover a range of topics centered around workforce training
    solutions in the healthcare field.
  </>
)

const IndustryInsightsHeroProps = {
  Content: () => <HeroContent />,
  title: 'Industry Insights in Healthcare',
}

export default IndustryInsightsHeroProps
